import React, { Component, useEffect, useState, useRef } from 'react';
import CountUp from 'react-countup';
import { connect } from 'react-redux';
import axios from 'axios';
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Redirect } from 'react-router-dom';
import { useHistory } from "react-router-dom";


import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { API_BASE_URL } from '../../config.js'
import DataTable, { defaultThemes } from 'react-data-table-component';


import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';

import Pagination from '../Pagination/Paginations.js';
import EntriesSelector from '../Pagination/EntriesSelector.js';
import useSortData from "../Pagination/SortData.js";

// import DataTable from 'datatables.net-react';
// import DT from 'datatables.net-dt';

// DataTable.use(DT);
import {
	statisticsAction,
	statisticsCloseAction
} from '../../actions/settingsAction.js';
import { Link } from 'react-router-dom/cjs/react-router-dom.min.js';
const HrManageApproval = (props) => {
	const sparkline1 = React.createRef();
	const sparkline2 = React.createRef();
	const sparkline3 = React.createRef();
	const sparkline4 = React.createRef();


	const handleStatistics = (e) => {
		statisticsAction(e)
	}
	const closeStatistics = (e) => {
		statisticsCloseAction(e)
	}

	const { fixNavbar, statisticsOpen, statisticsClose } = props;
	
	
	const today = new Date().toISOString().split("T")[0];


	const [user, setUser] = useState({
        start_date: today,
        end_date: today,
        employee_id:"ALL",
		department:"0"
		
    })



	

	
	const history = useHistory();
	const [data, setData]= useState([]);
	const [dataval, setdataval]= useState([]);
    const [shiftdataval, setshiftdataval]= useState([]);
    const [isVisible, setIsVisible] = useState(false);
	const [urlres, setUrlRes] = useState(false);
	const [style1,setStyle1]=useState(false);
	const [records, setRecords] = useState([]);
	const [loading, setLoading] = useState(false);
	const [approving, setApproving] = useState(false);
	const approvingRef = useRef(false);
	const { sortConfig, sortData, handleSort } = useSortData();


    const handelInput = (event) => {
        event.preventDefault();
        const { name, value } = event.target;
        console.log(name, value)
        setUser({ ...user, [name]: value });

        if (event.target.value === '1') {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
    }



        const [empinfo, setEmpInfo] = useState({
            emp_id: "",
            shift_code: "",
            shift_date:"",
            user_id:"",
            emp_info:"",
        })
    
    
    
    
        const handelEditInput = (event) => {
            event.preventDefault();
            const { name, value } = event.target;
            console.log(name, value)
            setEmpInfo({ ...empinfo, [name]: value });
    
            // if (event.target.value === '1') {
            //     setIsVisible(true);
            //   } else {
            //     setIsVisible(false);
            //   }
        }


		const [searchTerm, setSearchTerm] = useState("");
		const [currentPage, setCurrentPage] = useState(1);
		const [entriesPerPage,setEntriesPerPage]=useState(10);
		const searchableFields = [
  "employee_id",
  "employee_name",
  "dept_name",
  "shift_code",
  "shift_name",
  "shift_date",
  "day",
  "shift_time",
  "attendance_time",
];

const safe = (val) => String(val ?? "").toLowerCase();

const filteredItems =
  searchTerm.trim() === ""
    ? records
    : records.filter((item) =>
        searchableFields.some((field) =>
          safe(item[field]).includes(searchTerm.toLowerCase())
        )
      );

		const totalPages = Math.ceil(filteredItems.length / entriesPerPage);
		const indexOfLast = currentPage * entriesPerPage;
		const indexOfFirst = indexOfLast - entriesPerPage;
		// const filteredData = filteredItems.slice(indexOfFirst, indexOfLast);

		 const sortedItems = sortData([...filteredItems]);

	      const filteredData = sortedItems.slice(indexOfFirst, indexOfLast);
	  
		useEffect(() => {
		  setCurrentPage(1);
		}, [searchTerm]);
	  
		
	
	  const handleSearch = (event) => {
		//console.log(event.target.value);
		 setSearchTerm(event.target.value);
	  };

	  const clearInput = () => {
        setSearchTerm("");
      };
	
	


	    const handleDepartment = async () => {
	  
			axios.get(API_BASE_URL +'/showdepartment/', { headers : {
				   'Content-Type': 'application/json',
				   Authorization: `Bearer ${localStorage.getItem("authToken")}`
		   }})
			.then(res1 => setdataval(res1.data))
			.catch(err => console.log(err))
		   };
	  
	  
		   useEffect(() => {
			handleDepartment();
		  }, []);

 const [department, setDepartmentValue] = useState("0");
 const [employeeDropdownOptions,setEmployeeDropdownOptions]=useState([]);
 const [employeedet,setEmployeeValue] = useState("ALL");

 const [checkedItems, setCheckedItems] = useState({});


 const handleFirstDropdownChange = (event) => {
    const value = event.target.value;
    setDepartmentValue(value);

    // Trigger API call based on the selected value
    fetchSecondDropdownOptions(value);
  };


     // Fetch options for the second dropdown
	 const fetchSecondDropdownOptions = async (selectedValue) => {

	  try {
	  
	const response = await fetch(
		  API_BASE_URL + '/showdeptbase_hr_emp/'+selectedValue, {
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}
		); // Replace with your API URL
  
		const data = await response.json();
		console.log(data);

		setEmployeeDropdownOptions(data); // Assuming the API returns an array of options
	  } catch (error) {
		console.error("Error fetching second dropdown options:", error);
	  }
	};


	  // Handle second dropdown change
	  const handleSecondDropdownChange = (event) => {
		// setSecondDropdownValue(event.target.value);
		setEmployeeValue(event.target.value);
	  };




  useEffect(()=> {
	axios.get(API_BASE_URL +'/fetchshift', {
		headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
	})

	//.then(res =>console.log(res.data))
	 .then(res => setshiftdataval(res.data))
	.catch(err => console.log(err));
},[])



useEffect(() => {
  const defaults = {};
  records.forEach(item => {
    if (item.hr_status === 1) {
      defaults[item.id] = true;
    }
  });
  setCheckedItems(defaults);
}, [records]);





const handleSubmit = async (e) => {
    e.preventDefault();

	// alert(user.start_date);
	// alert(user.end_date);
	// alert(department);
	// alert(employeedet);
	setLoading(true);
    try {
      const response = await axios.post(API_BASE_URL +'/ondutyApprovalList',
		{ start_date: user.start_date, end_date: user.end_date, dept_id: department,user_id: employeedet }, 
		{
			headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
		}

);
 console.log(response.data.ondutyapproval);
      setRecords(response.data.ondutyapproval); // Assuming the API response contains the records in `response.data`
	  setLoading(false);
	} catch (error) {
      const res = error.response;
	    setRecords([]); // Clear previous data on error
    setLoading(false);
	if (!res) { toast.error('Network error'); return; }
	if (res.status === 422) {
	  const errs = res.data?.errors || {};
	  const firstMsg = Object.values(errs)[0]?.[0] || 'Validation failed';
	   toast.error(firstMsg, {
    position: 'bottom-right',
    autoClose: 5000,
    theme: 'colored',
    style: { backgroundColor: '#dc3545', color: '#fff' }
  });
	} else {
	  toast.error(res.data?.message || `Error ${res.status}`);
	}
    }
  };

 


  const handleUpdate = async (shift_code) => {

    // alert(shift_code)
    axios.get(API_BASE_URL + '/edit_shift_info/' + shift_code, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    })
    // .then(res1 => console.log(res1.data.shiftinfo[0]))
        .then(res1 => setEmpInfo(res1.data.shiftinfo[0]))
        .catch(err => console.log(err))
};


// useEffect(()=> {
//     axios.get(API_BASE_URL +'/fetchshift', {
//         headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
//     })

//     //.then(res =>console.log(res.data))
//      .then(res => setdataval(res.data))
//     .catch(err => console.log(err));
// },[])



const handleEditSubmit = (e) => {

    e.preventDefault();
    // alert(empinfo.emp_id);
    // alert(empinfo.shift_code);
    // alert(empinfo.shift_date);

    console.log(user);
    // setError(null);
    // setLoading(true);
    // e.preventDefault();
    axios.post(API_BASE_URL + '/update_shift_info', { emp_id: empinfo.emp_id, shift_code: empinfo.shift_code, attn_date: empinfo.shift_date }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    }).then(response => {
        // console.log(response.data);
        // // 	console.log(response.data.message);
        //  })

        var status = response.data.status;

        if (status == 200) {
            toast.success(response.data.message, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",

            });

            const timeout = setTimeout(() => {
                window.location.reload(); // Reload the current page
            }, 5000); // Refresh after 5 seconds

            return () => {
                clearTimeout(timeout); // Cleanup the timeout if the component unmounts
            };

        } else if (status == 401) {
            toast.error(response.data.message, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",

            });
        }
        else if (status == 400) {
            toast.error(response.data.message, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",

            });
        }


    }).catch(error => {
        // console.log(error);
        // console.log(error.response.data.message);




        toast.error(error.response.data.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",


        });

    });
};



const handleApproveSelected = async () => {
  const selectedIds = Object.keys(checkedItems).filter(
    (id) => checkedItems[id]
  );


  if (selectedIds.length === 0) {
    toast.error("No on-duty requests selected", {
      toastId: "no-onduty-selected",
      position: "bottom-right",
      theme: "colored",
    });
    return;
  }

  // block repeat clicks while an approval request is already running
  if (approvingRef.current) return;
  approvingRef.current = true;
  setApproving(true);

  try {
    const response = await axios.post(
      API_BASE_URL + "/approve_hr_onduty", // 👈 your API
      { onduty_ids: selectedIds },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        },
      }
    );

    if (response.data.status === 200) {
      toast.success(response.data.message, {
        position: "bottom-right",
        theme: "colored",
      });

      // ✅ UPDATE UI (no reload needed)
      setRecords((prev) =>
        prev.map((item) =>
          selectedIds.includes(String(item.id))
            ? {
                ...item,
                hr_status: 2, // approved
                hr_approve_status:
                  "<span class='text-success'>Approved</span>",
              }
            : item
        )
      );

      // ✅ Clear checkboxes
      setCheckedItems({});
    }
  } catch (error) {
    toast.error("Failed to approve on-duty requests", {
      position: "bottom-right",
      theme: "colored",
    });
  } finally {
    approvingRef.current = false;
    setApproving(false);
  }
};







    const columns = [
	{ label: "Action", key: "action_sort_onduty", sortable: true },
	{ label: "Emp Id", key: "employee_id", sortable: true },
	{ label: "Employee Name", key: "employee_name", sortable: true },
	{ label: "Department", key: "deparment_name", sortable: true },
  	{ label: "Date", key: "date", sortable: true },
	{ label: "Punch In", key: "punch_in", sortable: true },
	{ label: "address", key: "address", sortable: true },
	{ label: "Reason", key: "reason", sortable: true },
	{ label: "Status", key: "hr_status", sortable: true },

];

	return (
		<>


			<div>
				<div>
					<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
						<div className="container-fluid">

							<ToastContainer />

						
						</div>
					</div>


					 <div className="section-body mt-3">
										<div className="container-fluid">
											<div className="row clearfix">
												<div className="col-md-12">
													<div className="card">
														<div className="card-header d-flex justify-content-between align-items-center">
							<h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
							  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 16 16" fill="#1d3a8a" style={{ marginRight: "8px", verticalAlign: "-3px" }}>
							    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/><path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
							  </svg>
							  Manage Onduty
							</h3>
														</div>
														{/* <div className="card-header">
															<h3 className="card-title">My Shift</h3>
														</div> */}
														<div className="card-body">
															 <form onSubmit={handleSubmit} > 
					
																<div className="row g-3 align-items-end">
					
																<div className="col-md col-sm-6">
																	<div className="form-group">
																	<label className="form-label">From Date</label>
																	<DatePicker
																	selected={user.start_date ? new Date(user.start_date) : null}
																	onChange={(date) => {
																		const value = date ? date.toLocaleDateString("en-CA") : "";
																		setUser((prev) => ({ ...prev, start_date: value }));
																	}}
																	dateFormat="yyyy-MM-dd"
																	placeholderText="Select From Date"
																	className="form-control"
																	wrapperClassName="w-100"
																	maxDate={user.end_date ? new Date(user.end_date) : null}
																	/>
																	</div>
																</div>
					
																<div className="col-md col-sm-6">
																	<div className="form-group">
																	<label className="form-label">To Date</label>
																	<DatePicker
																	selected={user.end_date ? new Date(user.end_date) : null}
																	onChange={(date) => {
																		const value = date ? date.toLocaleDateString("en-CA") : "";
																		setUser((prev) => ({ ...prev, end_date: value }));
																	}}
																	dateFormat="yyyy-MM-dd"
																	placeholderText="Select To Date"
																	className="form-control"
																	wrapperClassName="w-100"
																	minDate={user.start_date ? new Date(user.start_date) : null}
																	/>
																	</div>
																</div> 
					
																{/* <div className="col-md-2 col-sm-6">
														<div className="form-group">
															<input type="text" className="form-control" name="menu_icon" value={user.menu_icon}
													onChange={handelInput} placeholder="Menu Icon" />
														</div>
													</div> */}
					


															<div className="col-md col-sm-12">
															<div className="form-group">
																	<label className="form-label">Department</label>

															<select className="form-control show-tick" style={{ height: "38px" }} name="department"  isSearchable={true} // Enable search
														placeholder="Select a fruit..." value={department}  onChange={handleFirstDropdownChange}>
															<option value="0">Select Department</option>
																{dataval.map(option => (
																<option key={option.department_id} value={option.department_id}>
																{option.department_name}
																</option>
																))}
														</select>
																
															</div>
														</div>



																<div className="col-md col-sm-12">
															<div className="form-group">
																	<label className="form-label">Employee</label>
															<select className="form-control show-tick" style={{ height: "38px" }}
														value={employeedet} name="employeedet"
														onChange={handleSecondDropdownChange}
														disabled={employeeDropdownOptions.length === 0}
														>
														<option value="0">Select Employee</option>
														{employeeDropdownOptions.map((option) => (
															<option key={option.user_id} value={option.user_id}>
															{option.first_name} {option.last_name}
															</option>
														))}
														</select>
															</div>
														</div>
					
														
														
												
					
													
													
					
					
															<div className="col-md-auto col-sm-6">
														<div className="form-group">
					
													<button type="submit" className="btn btn-primary">
													GET
												</button>
					
												
												</div>
												</div>
					
					
					
												{/* <div className="col-md-2 col-sm-6">
														<div className="form-group">
					
												   
					
												<Link to={`/attendancecalendar`} className="btn btn-primary">Attendance Calendar</Link>
					
												</div>
												</div> */}
					
					
												</div>
					
												
												   
					
															   
					
					
															
						
															
																
															 </form>
														</div>
													</div>
												</div>
					
											</div>
										</div>
									</div>


										<div className="section-body">
											<div className="container-fluid">
												<div className="tab-content">
													<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
														<div className="card">
					
															<div className="card-header">
																
																<div
  className="card-options"
  style={{
    display: "flex",
    alignItems: "center",
    gap: "12px",
  }}
>
  <EntriesSelector
    entriesPerPage={entriesPerPage}
    setEntriesPerPage={setEntriesPerPage}
    setCurrentPage={setCurrentPage}
  />

  {/* 🔽 SEARCH BOX WRAPPER */}
  <div style={{ position: "relative", width: "200px" }}>
    <input
      type="text"
      className="form-control form-control-sm"
      placeholder="Search"
      value={searchTerm}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
      }}
      style={{
        width: "100%",
        height: "30px",
        fontSize: "13px",
        borderRadius: "4px",
        paddingRight: "28px", // ✅ space for X
      }}
    />

    {searchTerm.length > 0 && (
      <span
        onClick={clearInput}
        style={{
          position: "absolute",
          right: "8px",        // ✅ INSIDE input
          top: "50%",          // ✅ vertically centered
          transform: "translateY(-50%)",
          cursor: "pointer",
          color: "#aaa",
          fontSize: "16px",
          userSelect: "none",
        }}
      >
        ✖
      </span>
    )}
  </div>
</div>
															</div>
					
															{/* <div>
																<DataTable 
																columns={column} 
																data={data}
																customStyles={customStyles}
																pagination 
																highlightOnHover
																responsive
																paginationPerPage={10}
																paginationRowsPerPageOptions={[25,50,100,500]}
																className="table table-striped table-bordered"> 
															</DataTable>
															</div> */}
					
					
					
					
					
					
					
					{/* Loading Spinner */}
					{loading && (
																<div className="card-body">
																<div class="d-flex justify-content-center">
						   <div class="spinner"></div>
						   </div>
						   </div>
						  )}
					
					{!loading && (
															<div className="card-body">
															
																<div className="table-responsive sticky-table-wrap">
							
					
						
						  
								<table className="table table-hover table-striped table-vcenter text-nowrap mb-0 sticky-table">
																		<thead>
																			<tr>

																				<th
      onClick={() => handleSort("checkbox")}
      style={{ cursor: "pointer", whiteSpace: "nowrap" }}
    >
      {records.length > 0 && (
        <input
          type="checkbox"
          checked={
            Object.values(checkedItems).length > 0 &&
            Object.values(checkedItems).every(Boolean)
          }
          onClick={(e) => e.stopPropagation()}
          onChange={(e) => {
            const newChecked = {};
            records.forEach(item => {
              if (item.hr_status === 1) {
                newChecked[item.id] = e.target.checked;
              }
            });
            setCheckedItems(newChecked);
          }}
        />
      )}
    </th>
                                                                                {/* <th>Action</th> */}
																			     {columns.map((col) => (
																<th
																	key={col.key}
																	onClick={col.sortable ? () => handleSort(col.key) : null}
																	style={{ cursor: col.sortable ? "pointer" : "default" }}
																>
																	{col.label}
																	{col.sortable && (
																sortConfig.key === col.key
																	? (sortConfig.direction === "asc" ? " ▲" : " ▼")
																	: " ⇅"   // <-- DEFAULT SORT ICON
																)}
																	</th>
																))}
																				
																			</tr>
																		</thead>
																		<tbody>
																		{records.length > 0 ? (
																				filteredData.map((record) => {

                                                                                    let action;
																					let shiftcode=`${record.user_id}---${record.shift_date}`;
																					
                                                           
                                                              if (record.curr_date_strtotime > record.shift_date_strtotime ){
                                                                    action = '';
                                                                  } else {
                                                                    action = <button type="button" onClick={() =>{ handleUpdate(shiftcode)}} className="btn btn-icon btn-sm" title="Edit" data-toggle="modal"
																	data-target="#exampleEditModal">
																	<i className="fa fa-edit" />
																	</button>;
																  }
                                                               return(



																					<tr key={`${record.employee_id}-${record.date}`}>
 <td>
    {record.hr_status === 1 && (
      <input
        type="checkbox"
        checked={checkedItems[record.id] || false}
        onChange={(e) =>
          setCheckedItems({
            ...checkedItems,
            [record.id]: e.target.checked,
          })
        }
      />
    )}
  </td>

  <td className="d-flex">
	{record.hr_status === 1 && (
	  <Link to={`/onduty-approval-details?id=${record.id}`}>
		<i className="fe fe-maximize" />
	  </Link>
	)}
  </td>
  <td>{record.employee_id}</td>
  <td>{record.employee_name}</td>
  <td>{record.department_name}</td>
  <td>{record.date}</td>
  <td>{record.punch_in}</td>
  <td>{record.address}</td>
  <td>{record.reason}</td>
  <td>{ReactHtmlParser(record.hr_approve_status)}</td>
</tr>

                                                               )
})
																			) : (
																				<tr>
																				<td colSpan="7" style={{ color: 'red', textAlign: 'center',fontWeight: "bold" }}>No records found</td>
																				</tr>
																			)}
					
																
																		</tbody>
																	</table>
																</div>
															
								 				<Pagination
												currentPage={currentPage}
												totalPages={totalPages}
												onPageChange={setCurrentPage}
												/>	


<div className="mt-3 text-end">
  <button
    className="btn btn-primary"
     onClick={handleApproveSelected}
     disabled={approving}
  >
    {approving ? "Approving..." : "Approve Onduty"}
  </button>
</div>


													
					
															</div> 
					)
					}
														</div>
													</div>
						
												
												</div>
											</div>
										</div>

				</div>
			</div>



            <div
				className="modal fade"
				id="exampleEditModal"
				tabIndex={-1}
				role="dialog"
				aria-labelledby="exampleModalLabel"
				aria-hidden="true"
			>
				<form onSubmit={handleEditSubmit}>
					<div className="modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="exampleModalLabel">
									Edit Shift Info
								</h5>
								<button type="button" className="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">×</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="row clearfix">
									<div className="col-md-4 col-sm-6">
										<div className="form-group">
										<label className="form-label">Employee Info<span className="form-required">*</span></label>
											<input type="text" className="form-control" name="emp_info" value={empinfo.emp_info}
												onChange={handelEditInput} placeholder="Url Name" readOnly/>
										<input type="hidden" name="emp_id" value={empinfo.emp_id}/>
										</div>
									</div>
									<div className="col-md-4 col-sm-6">
										<div className="form-group">
										<label className="form-label">Shift Date <span className="form-required">*</span></label>
											<input type="text" className="form-control" name="shift_date" value={empinfo.shift_date}
												onChange={handelEditInput} readOnly placeholder="" />
										</div>
									</div>

									<div className="col-md-4 col-sm-6">
									<div className="form-group">
									<label className="form-label">Shift Code <span className="form-required">*</span></label>
									<select name="shift_code" id="shift_code" className="form-control custom-select" value={empinfo.shift_code} onChange={handelEditInput}>
										
											{/* <option value="">ALL</option> */}
											{shiftdataval.map(option => (
											<option key={option.shift_code} value={option.shift_code}>
												{option.shift_name}
											</option>
											))}
										</select>
                                    </div>
									</div>

								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-secondary" data-dismiss="modal">
									Close
								</button>
								<button type="submit" className="btn btn-primary">
									Save changes
								</button>
							</div>
						</div>
					</div>

				</form>

			</div>




		</>
	);

}



const mapStateToProps = (state) => ({
	fixNavbar: state.settings.isFixNavbar,
	statisticsOpen: state.settings.isStatistics,
	statisticsClose: state.settings.isStatisticsClose,
})

const mapDispatchToProps = (dispatch) => ({
	statisticsAction: (e) => dispatch(statisticsAction(e)),
	statisticsCloseAction: (e) => dispatch(statisticsCloseAction(e))
})
export default connect(mapStateToProps, mapDispatchToProps)(HrManageApproval);